import React from 'react';
import Joyride from 'react-joyride';

const brand = '#008f5a';

const steps = [
  {
    target: '[data-tour="create-group"]',
    placement: 'bottom',
    title: 'Create Group',
    content: 'Create a home base for your crew or club.'
  },
  {
    target: '[data-tour="profile"]',
    placement: 'bottom',
    title: 'Your Profile',
    content: 'Update settings, email alerts, and preferences.'
  },
  {
    target: '[data-tour="invite"]',
    placement: 'top',
    title: 'Invite',
    content: 'Invite your favorite hitting partner'
  },
  {
    target: '[data-tour="propose"]',
    placement: 'bottom',
    title: 'Propose New Play',
    content: 'Suggest times to play; your group gets notified.'
  },
  {
    target: '[data-tour="join-group"]',
    placement: 'top',
    title: 'Join Group',
    content: 'Find and join public groups near you.'
  },
];

export default function GuidedTour({ run, onClose }) {
  const handle = (data) => {
    const { status, action, index, type } = data;
    
    console.log('Tour step:', { status, action, index, type, step: steps[index] });
    
    // Close + persist when finished or skipped
    if (status === 'finished' || status === 'skipped') {
      localStorage.setItem('tnow_tour_seen_v1', '1');
      onClose();
    }
    
    // If user clicks the final primary button, send them to Join Group
    if (type === 'step:after' && action === 'next' && index === steps.length - 1) {
      const joinBtn = document.querySelector('[data-tour="join-group"]');
      if (joinBtn && joinBtn instanceof HTMLElement) {
        joinBtn.click();
      }
    }
  };

  // Debug: Check if invite button exists when tour runs
  React.useEffect(() => {
    if (run) {
      const inviteBtn = document.querySelector('[data-tour="invite"]');
      console.log('Invite button found:', inviteBtn);
      if (inviteBtn) {
        console.log('Invite button visible:', inviteBtn.offsetParent !== null);
        console.log('Invite button position:', inviteBtn.getBoundingClientRect());
      }
    }
  }, [run]);

  return (
    <Joyride
      run={run}
      steps={steps}
      continuous
      showSkipButton
      hideCloseButton
      disableOverlayClose
      disableScrolling={false}
      scrollToFirstStep
      spotlightClicks={false}
      disableBeacon
      styles={{
        options: {
          primaryColor: brand,
          zIndex: 10000,
          overlayColor: 'rgba(0,0,0,0.55)'
        },
        spotlight: {
          backgroundColor: 'transparent',
          borderRadius: 0
        },
        tooltip: {
          borderRadius: 12
        },
        tooltipArrow: {
          color: brand,
          transform: 'scale(1.8)',
          filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.15))'
        },
        buttonNext: {
          borderRadius: 10,
          padding: '10px 14px'
        },
        buttonBack: {
          marginRight: 8
        },
        tooltipTitle: {
          fontWeight: 700
        }
      }}
      locale={{
        back: 'Back',
        close: 'Got it',
        last: 'Join Group now to start playing',
        next: 'Next',
        skip: 'Skip tour'
      }}
      callback={handle}
    />
  );
} 